import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButton';
import './embla.css';

const OPTIONS = { align: 'start' }

function initializeCarousel() {
    const emblaNode = document.querySelector('.embla')
    if (emblaNode) {
        const viewportNode = emblaNode.querySelector('.embla__viewport')
        const dotsNode = emblaNode.querySelector('.embla__dots')

        const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

        const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
            emblaApi,
            dotsNode
        )

        emblaApi.on('destroy', removeDotBtnsAndClickHandlers)
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCarousel, {once: true});
} else {
    initializeCarousel();
}
